
import { filter, mergeMap, map, mapTo } from 'rxjs/operators'
import { Epic } from 'interfaces/middleware'
import { CANCEL_SUBSCRIPTION, cancelSubscriptionActionCreator, CANCEL_SUBSCRIPTION_CONFIRM, GetSubscriptionAction } from 'actions/subscriptionActions'
import { combineEpics } from 'redux-observable'
import { GET_SUBSCRIPTION_URL, CANCEL_SUBSCRIPTION_URL } from 'interfaces/ajax'
import { of } from 'rxjs'
import { modifyFloatingPaneActionCreator, OPEN_SUBSCRIPTION_PANE, openSubscriptionPageActionCreator } from 'actions/floatingPanesActions'
import { INSIGHT_CTA_CLICK } from 'actions/insightsActions'
import { byType } from 'rxOperators/byType'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { catchAjaxSafe } from 'rxOperators/catchSafe'
import { subscription2Epic } from 'epics/subscription2Epic'

const getSubscriptionEpic: Epic = (action$, _store, { get }) =>
  action$
    .pipe(filterRequestOfType(GetSubscriptionAction.type, 'request')).pipe(
      mergeMap((action) => {
        return get(GET_SUBSCRIPTION_URL).pipe(
          map(({ response }) => {
            return action.success(response)
          }))
          .pipe(catchAjaxSafe((error) => {
            return of(action.fail({ errorCode: error.status }))
          }))
      }))

const launchCancelSubscriptionEpic: Epic = (action$) =>
  action$
    .pipe(filterRequestOfType(CANCEL_SUBSCRIPTION_CONFIRM, 'success')).pipe(
      mapTo(cancelSubscriptionActionCreator.request({})))

const cancelSubscriptionEpic: Epic = (action$, _store, { post }) =>
  action$
    .pipe(filterRequestOfType(CANCEL_SUBSCRIPTION, 'request')).pipe(
      mergeMap((action) => {
        return post(CANCEL_SUBSCRIPTION_URL, { body: {}}).pipe(
          map(({ response }) => {
            return cancelSubscriptionActionCreator.success(action.payload.params, response)
          }))
          .pipe(catchAjaxSafe((error) => {
            return of(cancelSubscriptionActionCreator.fail(action.payload.params, error.status))
          }))
      }))

const handleCTAEpic: Epic = (action$) => action$.pipe(
  byType(INSIGHT_CTA_CLICK),
  filter(({ payload }) => !!(payload.type === 'popup' && payload.cta.type === 'subscription')),
  map(openSubscriptionPageActionCreator)
)

const openSubscriptionPaneDefaultEpic: Epic = (action$) => action$.pipe(
  byType(OPEN_SUBSCRIPTION_PANE),
  mergeMap(() => {
    return of(modifyFloatingPaneActionCreator('subscription', {
      mode: 'welcome',
    }))
  })
)

export const subscriptionEpic = combineEpics(
  getSubscriptionEpic,
  launchCancelSubscriptionEpic,
  cancelSubscriptionEpic,
  handleCTAEpic,
  subscription2Epic,
  openSubscriptionPaneDefaultEpic,
)
